<script lang="ts">
	import { format } from 'svelte-i18n';
	import { FlexibleCard, PlainTable, Button } from '@Shelly/shelly-design-system';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	import EvChargerManualLimitV2 from './EvChargerManualLimitV2.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import EvChargerStatusesV2 from './EvChargerStatusesV2.svelte';

	export let device: Device, statuses: VCInterfaceStatus[];
</script>

<EvChargerStatusesV2 {statuses} />
<EvChargerManualLimitV2 {device} {statuses} />
<FlexibleCard
	class="mb-s"
	padding="m"
	mainContentPrioritySlot="both"
	header={$format('label_real_time_data', {
		default: 'Real-time data',
	})}
	backgroundColor="--color-0"
	icon="far fa-signal-stream"
>
	<PlainTable class="width-full">
		<tbody>
			{#each ['a', 'b', 'c'] as phase}
				<tr>
					<th
						>{$format(`label_phase_${phase}`, {
							default: `phase ${phase}`,
						})}</th
					>
					<td>{statuses.find((i) => i.name == `${phase}_power`)?.value || 'N/A'}</td>
				</tr>
			{/each}
		</tbody>
	</PlainTable>
	<PlainTable class="width-full">
		<Button
			variant="secondary"
			class="mt-s width-full"
			size="m"
			on:click={() => {
				navigateToSetting(device.id, 'charts');
			}}
		>
			{$format('button_view_live_consumption', {
				default: 'View live consumption',
			})}
		</Button>
	</PlainTable>
</FlexibleCard>
